import { FormikErrors, FormikTouched } from "formik";
import get from "lodash/get";

export function fieldErrorHandler<T>(
  name: keyof T,
  errors: FormikErrors<T>,
  touched: FormikTouched<T>
) {
  return get(errors, name) && get(touched, name)
    ? get(errors, name)
    : undefined;
}
